import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService, ROLES } from './auth/auth.service';
import { PatientService } from './services/patient.service';
import { SidebarStateService } from './services/sidebar-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  isFirstAccess: boolean = true;
  isSidebarCollapsed: boolean = false;
  patientSubscription: Subscription;
  private destroy$ = new Subject<void>();

  constructor(
    private patientService: PatientService,
    private authService: AuthService,
    private router: Router,
    private sidebarStateService: SidebarStateService
  ) { }

  get isMember(): boolean {
    const role = this.authService.getUserRole();
    const institutionId = this.authService.getInstitutionId();
    const isAppRoute = this.router.url.startsWith('/app');
    const isFirstAccessRoute = this.router.url.includes('first-access');
    return role === ROLES.MEMBER && isAppRoute && !isFirstAccessRoute && institutionId === '27';
  }

  get isSidebarVisible(): boolean {
    const role = this.authService.getUserRole();
    return this.isFirstAccess && role != null && this.router.url.includes('app');
  }

  ngOnInit() {
    this.isSidebarCollapsed = this.sidebarStateService.collapsed;
    this.sidebarStateService.collapsed$.pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.isSidebarCollapsed = val;
    });
    this.patientService.haveDatePassword$.subscribe((datePassword) => {
      this.isFirstAccess = datePassword;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
